let LogEnv = /*#__PURE__*/function (LogEnv) {
  LogEnv["dev"] = "dev";
  LogEnv["stage"] = "stage";
  LogEnv["real"] = "real";
  return LogEnv;
}({});
const GLOBAL_COMMON_LOGS_ENV = {
  env: LogEnv.real
};
const initCommonLogsEnv = env => {
  GLOBAL_COMMON_LOGS_ENV.env = env;
};

export { GLOBAL_COMMON_LOGS_ENV, LogEnv, initCommonLogsEnv };
